import { useEffect, useState } from "react";

// With Tailwind, you can use pointer-coarse instead to detect touch devices
export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const hasTouchStart = "ontouchstart" in window;
    const hasMaxTouchPoints = navigator.maxTouchPoints > 0;
    setIsTouchDevice(hasTouchStart || hasMaxTouchPoints);
  }, []);

  return isTouchDevice;
};
